import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AsyncApiComponent from '@asyncapi/react-component';
import '@asyncapi/react-component/styles/default.min.css';

import { fetchData } from '../../../helpers/methods';

import SpinnerContainer from '../../../component-library/spinner-container';

const InteractiveDocumentationEvent = () => {
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [asyncApiData, setAsyncApiData] = useState({});

	const config = {
		show: {
			servers: true,
		},
		sidebar: {
			showServers: true,
		},
	};

	const getAsyncApiData = () => {
		setLoading(true);
		fetchData({
			uri: `/api/web/catalog/item/${id}/asyncapi/docs`,
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					body.text().then(content => {
						setAsyncApiData(content);
						setLoading(false);
					});
				} else {
					setLoading(false);
					setError(true);
				}
			})
			.catch(() => {
				setLoading(false);
				setError(true);
			});
	};

	useEffect(() => {
		getAsyncApiData();
	}, []);

	return (
		<>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && !error && (
				<div className="interactive-docs__event-container margin-bottom-16">
					<AsyncApiComponent schema={asyncApiData} config={config} />
				</div>
			)}
			{error && (
				<>
					<h3>Oops! Something went wrong</h3>
					<p className="large-text margin-bottom-32">Please refresh the page and try again, if the problem persists please contact your system administrator.</p>
				</>
			)}
		</>
	);
};

export default InteractiveDocumentationEvent;
